import { connect } from 'react-redux';

const mapStateToProps = ({ tableCategories = {} }) => {
  const { Selected } = tableCategories;
  return { Selected };
};
export default (WrappedComponent) => connect(mapStateToProps, null)(WrappedComponent);
